import { React, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export function BasicAddressTable({ headers, rows }) {

    useEffect(() => {
        console.log(headers)
    }, [headers, rows]);
    

    return (
        <TableContainer component={Paper} sx={{ height: "500px" }}>
            <Table stickyHeader sx={{ minWidth: 750 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {
                            headers.map((h) => (
                                <TableCell key={h}>{h}</TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows?.map((row) => (
                        <TableRow
                            key={row.title}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.title}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine1}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine2}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine3}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine4}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine5}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.addressLine6}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}